/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Scaffold from '@/Scaffold';
import showErrorMessage from '@/util/showErrorMessage';
import Config from '@config/Config';

import InternalLoginPage from '../pages/InternalLoginPage';
import HandleOTDSRESTTicketAuthentication from '../services/HandleOTDSRESTTicketAuthentication';

export default async function ShowInternalCACLogin() {
  // Messenger().hideAll();

  const otdsTicket = getCookie(Config.getOTDSTicketCookieName());

  // If an otds ticket cookie exists, attempt to log the user in
  if (otdsTicket) {
    try {
      await HandleOTDSRESTTicketAuthentication(otdsTicket);
      return;
    } catch (error) {
      showLoginError();
    }
  }

  Scaffold.getRegion('content').show(new InternalLoginPage());
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function showLoginError() {
  showErrorMessage({
    errorCode: 'loginError',
    errorTitle: 'Login Error',
    errorMessage: 'An error occurred while attempting to authenticate. If you have never accessed your internal account before, you may require additional permissions for access. Please contact an administrator.'
  });
}
